var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invitation-button-container"},[_c('span',{staticClass:"material-icons-outlined rotate-loading-icon"},[_vm._v("refresh")])])
}]

export { render, staticRenderFns }